//#region redux
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
//#endregion
//#region types
import { DialogEnums } from "models/enums";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region components
import CreateReconciliationExportView from "./createExportView";
//#endregion
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { LocalizationHelperInstance } from "utils/helpers";

function useCreateExportDialog() {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const displayCreateExportDialog = async (onSubmit: () => void) => {
    dispatch(
      displayDialog({
        isOpen: false,
        title: `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Accounting.CreateExport)}?`,
        dialogType: DialogEnums.DialogType.Message,
        titleIcon: IconDefinitionConstants.WTransfer,
        actions: [
          {
            text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Accounting.StartExport),
          },
        ],
        children: <CreateReconciliationExportView />,
        onSubmit: onSubmit,
      })
    );
  };

  return { displayCreateExportDialog };
}

export default useCreateExportDialog;
